import { ChangeDetectorRef, Component, Input, NgZone, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ApiService } from "src/app/services";
import { PfPlan } from "src/app/generated-models/PfPlan";

@Component({
  standalone: false,
  templateUrl: "./pf-plan-batch-approval-modal.component.html",
  styleUrls: ["../../../../styles.scss"],
})
export class PfPlanBatchApprovalModalComponent implements OnInit {
  @Input() title: string;
  @Input() pfPlans: PfPlan[];

  public aggregatedResult: string[] = [];
  public isCompleted = false;

  constructor(
    public activeModal: NgbActiveModal,
    protected apiService: ApiService,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
  ) { }
  async ngOnInit(): Promise<void> {
    await this.batchApprovalPfPlans();
  }

  close(): void {
    this.activeModal.close(true);
  }

  async batchApprovalPfPlans() {
    this.isCompleted = false;
    this.aggregatedResult = [];

    await Promise.all(
      this.pfPlans.map(async (pfPlan) => {
        try {
          await this.apiService.approvePfPlan(pfPlan.ServiceTreeId, pfPlan.Version).toPromise();
          this.appendResult(`Approve pf plan <b>${pfPlan.ServiceTreeId}</b> successfully`);
        } catch (ex) {
          this.appendResult(`Approve pf plan <b>${pfPlan.ServiceTreeId}</b> failed with error: ${ex}`);
        }
      })
    );

    this.ngZone.run(() => {
      this.isCompleted = true;
      this.cdr.detectChanges();
    });
  }

  private appendResult(message: string) {
    this.aggregatedResult.push(message);
    this.ngZone.run(() => {
      this.cdr.detectChanges();
    });
  }
}
